import { TranslateService } from '@ngx-translate/core';

export function dateTimeLocaleFactory(translateService: TranslateService): string {
  return translateService.currentLang;
}
